import { appSync, isAnyOf, startListening } from '@bonanza-social/toolkit/state';
import { statusChanged } from '@bonanza-social/status/state';
import { fetchShopSlots, purchaseShopSlot } from './slots.slice';

startListening({
  matcher: isAnyOf(appSync, statusChanged, purchaseShopSlot.fulfilled),
  effect: (_, { dispatch }) => {
    dispatch(fetchShopSlots());
  },
});
